import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { IContributionMarginLevel } from '../../../../models/contribution-margin-level.model';
import { Observable } from 'rxjs';
import { IContributionMarginLevelState } from '../../../../services/facades/master-data/contribution-margin-level-state.model';
import { ContributionMarginLevelFacade } from '../../../../services/facades/master-data/contribution-margin-level-facade.service';

@Component({
    selector: 'app-cost-type-dialog',
    templateUrl: './contribution-margin-level-dialog.component.html',
    styleUrls: [ './contribution-margin-level-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContributionMarginLevelDialogComponent implements OnInit, AfterViewInit {
    public contributionMarginLevelState$: Observable<IContributionMarginLevelState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        private myMatDialogRef: MatDialogRef<ContributionMarginLevelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IContributionMarginLevel,
        private myContributionMarginLevelFacade: ContributionMarginLevelFacade,
    ) {
    }

    public ngOnInit(): void {
        this.contributionMarginLevelState$ = this.myContributionMarginLevelFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costGroup: IContributionMarginLevel) => {
            this.validateDialogFields(costGroup);
        });
    }

    public async save(): Promise<void> {
        const data: IContributionMarginLevel = this.formGroup.value as IContributionMarginLevel;
        if (isNullOrUndefined(this.data.id)) {
            await this.myContributionMarginLevelFacade.addContributionMarginLevel(data);
        } else {
            data.id = this.data.id;
            await this.myContributionMarginLevelFacade.editContributionMarginLevel(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(contributionMarginLevel: IContributionMarginLevel): void {
        // Validations to disable saving/editing
        if (!contributionMarginLevel.name
            || !contributionMarginLevel.order) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }

}
